import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import ExclusiveContainer from '../components/ExclusiveContainer'

export default function N25_10_24() {
  return (
    <NoteContainer date={'24/10/2025'} version="20.15.0">
      <VStack w="full">
        <ModuleContainer moduleName="VULNERABILITY_ALERTS">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle important={true}>Central de mensageria no perfil do alertas</TaskTitle>
                <TaskBreadcrumb>Alertas/ Perfil do alerta</TaskBreadcrumb>
                <TaskDescription>
                  Agora o perfil do alerta conta com uma central de mensageria única onde os participantes podem se
                  comunicar através de mensagens geradas via interface
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ExclusiveContainer category="ADJUSTMENTS" institutions={['teste', 'treinamento', 'agsus']}>
          <ModuleContainer moduleName="CITIZEN_PORTAL">
            <VStack w="full">
              <CategoryContainer category="ADJUSTMENTS">
                <Box>
                  <TaskTitle important={true}>Automação do serviço CAT - Comunicação de Acidente de Trabalho</TaskTitle>
                  <TaskBreadcrumb>Solicitação de serviço</TaskBreadcrumb>
                  <TaskDescription>Criada automação com regras próprias do serviço.</TaskDescription>
                </Box>
              </CategoryContainer>
            </VStack>
          </ModuleContainer>
        </ExclusiveContainer>

        <ModuleContainer moduleName="REGULATION">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle important={true}>Edição das ações do regulador</TaskTitle>
                <TaskBreadcrumb>Regulação/ Reguladores</TaskBreadcrumb>
                <TaskDescription>
                  Agora será possível editar e configurar ações especificas do regulador em cada serviço
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
